var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82843 1.17157C5.26633 -0.390524 2.73367 -0.390524 1.17157 1.17157C-0.390524 2.73367 -0.390524 5.26633 1.17157 6.82843L4 4L6.82843 1.17157ZM49.2548 53.2548C51.464 53.2548 53.2548 51.464 53.2548 49.2548L53.2548 13.2548C53.2548 11.0457 51.464 9.25483 49.2548 9.25483C47.0457 9.25483 45.2548 11.0457 45.2548 13.2548L45.2548 45.2548L13.2548 45.2548C11.0457 45.2548 9.25483 47.0457 9.25483 49.2548C9.25483 51.464 11.0457 53.2548 13.2548 53.2548L49.2548 53.2548ZM4 4L1.17157 6.82843L46.4264 52.0833L49.2548 49.2548L52.0833 46.4264L6.82843 1.17157L4 4Z",
    fill: "#00FFA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2ee8b65332a169678febe4b246a90358.svg";
export { ForwardRef as ReactComponent };